// @ts-nocheck
import { LitElement, css, html } from 'lit'
import '../copy-click/copy-click.js'
import { go } from '../../../../shared/router/router-mixin.js'
import routes from '../../../../shared/router/routes.js'
import { settingsIcon, checkMark } from '../../../../shared/assets/icons.js'
import alertTextIndicator from '../../../../shared/components/alert-text-indicator.js'
import { getWalletVerificationStatus } from '../../../data/services/verification.service.js'
import {
  accountsAreEqual,
  truncateWalletAddress,
} from '../../../utilities/crypto.js'
import { getSessionUser } from '../../../utilities/session.js'
import { toast } from '../../../utilities/toast.js'
import { featureFlags } from '../../../utilities/feature-flags.js'
export const WalletCardEvents = {
  SELECTED_WALLET: 'selected-wallet',
}

class WalletCardElement extends LitElement {
  static properties = {
    wallet: { type: Object },
    selected: { type: Boolean },
    verified: { type: Boolean },
  }

  constructor() {
    super()
    this.selected = null
    this.verified = false
  }

  async connectedCallback() {
    super.connectedCallback()
    // TODO: fix wallet verification status
    try {
      const status = await getWalletVerificationStatus(getSessionUser().userId)
      this.verified = status[0]?.status === 'approved'
    } catch (error) {
      console.error('Error getting wallet verification status:', error)
      this.verified = false
    }

    if (window.ethereum) {
      window.ethereum.on('accountsChanged', (accounts) => {
        window.Globals.checkWallets()
      })

      window.ethereum.on('chainChanged', (chainId) => {
        window.location.reload()
      })
    }
  }

  selectedWallet(event, account) {
    this.dispatchEvent(
      new CustomEvent(WalletCardEvents.SELECTED_WALLET, {
        bubbles: true,
        composed: true,
        detail: account,
      })
    )
  }

  setSelected(selected, account) {
    return accountsAreEqual(selected, account)
  }

  handleSettingClick() {
    if (window.Globals.selectedAccount == null) {
      toast('Please select a wallet')
      return
    }
    window.dispatchEvent(
      new CustomEvent('selected-account', {
        detail: { opened: false },
        bubbles: true,
        composed: true,
      })
    )
    go(routes.WALLET_SETTINGS.path)
  }

  balanceUnitConversion(balance) {
    const rawBalance = balance / 10 ** 18
    const balanceWithCommas = rawBalance.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })
    return `${balanceWithCommas}`
  }

  render() {
    // TODO: handle no wallet selected state. Current setup is just a placeholder
    if (!this.wallet) {
      return html`<h1>No wallet selected</h1>`
    }

    return html`
      <div class="wallet-card">
        <div class="card-header">
          ${featureFlags.FF_WALLET_VERIFICATION
            ? html` ${this.verified
                ? html`${this.wallet.name}</h1>`
                : html`<alert-text-indicator
                    text="Wallet Not Verified"
                    boxType="error"
                    iconType="error-icon"
                    ><h1>${this.wallet.name}</h1></alert-text-indicator
                  >`}`
            : html`${this.wallet.name}</h1>`}

          <span class="address">
            <copy-click .value=${this.wallet.address}
              ><h1>
                ${truncateWalletAddress(this.wallet.address)}
              </h1></copy-click
            >
            <span style="cursor: pointer;" @click=${this.handleSettingClick}
              >${settingsIcon}</span
            >
          </span>
        </div>
        <hr class="line-break" />

        ${this.wallet.accounts.map(
          (account) => html`
            <span class="role-option">
              <h1
                ?selected=${this.selected &&
                this.setSelected(this.selected, account)}
                @click=${(e) => this.selectedWallet(e, account)}
                id="role-name"
              >
                ${account.daoName} ${account.role}
                ${this.balanceUnitConversion(account.balance)}
                <span id="checkmark">${checkMark}</span>
              </h1>
            </span>
          `
        )}
      </div>
    `
  }

  static styles = css`
    h1 {
      color: var(--kula-deep-green);
    }
    .wallet-card {
      display: flex;
      flex-direction: column;
      width: var(--DialogueHeightLarge, 260px);
      padding: 10px;
      margin: auto;
      border-radius: 8px;
      background: var(--Color, #fff);
      border: 2px solid var(--white-2);
    }
    .card-header {
      width: 100%;
      height: 24px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      align-self: stretch;
    }
    .card-header h1 {
      color: var(--kula-green);
      font-family: Lato;
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
      line-height: 20px;
      white-space: nowrap;
    }
    .address {
      display: flex;
      width: 160px;
      justify-content: flex-end;
      align-items: center;
      gap: 8px;
    }
    .line-break {
      width: 100%;
      height: 1px;
      background: #e2e2e2;
      border: none;
    }
    .role-option {
      display: flex;
      flex-direction: row;
      justify-content: left;
      gap: 8px;
    }

    .role-option h1 {
      color: var(--DarkGrey, #828282);
      text-align: left;
      font-family: Lato;
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
      line-height: 20px;
      cursor: pointer;
    }

    .role-option h1[selected] {
      color: var(--Black, #252525);
    }

    .role-options svg {
      display: none;
    }

    h1[selected] > #checkmark {
      display: inline-flex;
    }

    #checkmark {
      display: none;
    }
  `
}

customElements.define('wallet-card', WalletCardElement)
export default WalletCardElement
